
import { LINKEDIN_OAUTH_POPUP_IDENTIFIER } from '@/helpers/linkedin';
import Vue from 'vue';

export default Vue.extend({
  beforeRouteEnter(from, to, next) {
    next(async (vm: any) => {
      if (!vm.linkedinOAuthCode) {
        vm.$router.push({ name: 'home' });
      }
    });
  },
  computed: {
    linkedinOAuthCode(): string {
      return (this.$route.query.code as string) ?? '';
    },
  },
  mounted() {
    window.opener.postMessage(
      { code: this.linkedinOAuthCode, from: LINKEDIN_OAUTH_POPUP_IDENTIFIER },
      window.location.origin,
    );
  },
});
